import axiosInstance from "./axiosInstance";

export const getConversations = async () => {
  const response = await axiosInstance.get("/posts/conversations/");
  return response.data?.results || response.data || [];
};

export const createConversation = async (userId) => {
  const response = await axiosInstance.post("/posts/conversations/", {
    user_id: userId,
  });
  return response.data;
};

export const getMessages = async (convoId) => {
  const response = await axiosInstance.get(`/posts/messages/${convoId}/`);
  return response.data?.results || response.data || [];
};

export const sendMessage = async (convoId, text, sharedPostId = null) => {
  const response = await axiosInstance.post(`/posts/messages/${convoId}/`, {
    text,
    shared_post_id: sharedPostId,  // ✅ Post share
  });
  return response.data;
};

export const markSeen = async (messageId) => {
  const response = await axiosInstance.post(`/posts/seen/${messageId}/`);
  return response.data;
};

export const getShareContacts = () =>
  axiosInstance.get('/posts/messages/share-contacts/');

export const sharePostToDM = (postId, recipientUserIds, optionalText = '') =>
  axiosInstance.post('/posts/messages/share-post/', {
    post_id: postId,
    recipient_user_ids: recipientUserIds,
    optional_text: optionalText,
  });